import { render, staticRenderFns } from "./PayRangeReadinessAmounts.vue?vue&type=template&id=b0f8a672&scoped=true"
import script from "./PayRangeReadinessAmounts.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeReadinessAmounts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeReadinessAmounts.vue?vue&type=style&index=0&id=b0f8a672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f8a672",
  null
  
)

export default component.exports